
export const CUSTOM_BRANDING = {
    option: '***custom***',
    label: 'Add Custom Logo',
};

export const THERAPIST_AID_BRANDING = {
    option: '***therapist-aid***',
    label: 'Therapist Aid',
};

export const NONE_BRANDING = {
    option: '***none***',
    label: 'No Logo',

    missing: 'none',
};

export const USER_BRANDING = { label: 'My Logo' };

export const CUSTOM_MODAL = {
    DEFAULT_LOGO_SIZE: 0,
};